module.exports = __webpack_public_path__ + "assets/img/creative-agency.d95827c2.png";